import { render, staticRenderFns } from "./inventory-query.vue?vue&type=template&id=3f54b7a6&scoped=true&"
import script from "./inventory-query.vue?vue&type=script&lang=js&"
export * from "./inventory-query.vue?vue&type=script&lang=js&"
import style0 from "./inventory-query.vue?vue&type=style&index=0&id=3f54b7a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f54b7a6",
  null
  
)

export default component.exports